import { FC, ReactElement, RefObject, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM } from '../../helpers/canUseDOM';
const canUseDom = canUseDOM();
const defaultContainer = canUseDom ? document.body : null;
export const Portal = props => {
  const {
    visible,
    keepMounted = true,
    children,
    scope
  } = props;
  const [container, setContainer] = useState(defaultContainer);
  const isPortalDisabled = scope === 'withoutportal';
  const isWasVisibleRef = useRef(false);
  useEffect(() => {
    if (typeof scope === 'object') {
      setContainer(scope.current);
    }
  }, [scope]);
  if (visible) {
    isWasVisibleRef.current = true;
  }
  const shouldClientRender = canUseDom && (visible || keepMounted && isWasVisibleRef.current);
  const shouldServerRender = !canUseDom && visible;
  if (!shouldClientRender && !shouldServerRender) {
    return null;
  }
  if (isPortalDisabled) {
    return children;
  }
  return container ? /*#__PURE__*/createPortal(children, container) : null;
};
if (process.env.NODE_ENV !== 'production') {
  Portal.displayName = 'Portal';
}